import { Injectable } from '@angular/core';
import { BaseControl, Custom,  Textbox, ParametroFiltro, TextArea, CondicionControl } from '@app/shared';
import { Validators } from '@angular/forms';
import { find } from 'rxjs/operators';


@Injectable()
export class ReportFilterFormService {
  constructor() { }

  /**
   *  Construye y retorna el formulario para modificar una reporte
   *
   * @return {*}  {BaseControl<any>[]}
   * @memberof ReportFilterFormService
   */
  getFormFilter(template: any, options: any, options2: any,
    report?: ParametroFiltro
  ): BaseControl<any>[] {
    let checkModal: CondicionControl[] = [];
    let fieldModal: any = options.find((x: {key:any, value:string, others: string; }) => x.key == 'selector');
    if (fieldModal){
      checkModal.push({
          campoDepende: 'cboTipoCampo',
          siEs: 'Igual',
          valor: fieldModal.value,
          accion: 'Mostrar'
      })
    }
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'txtLabel',
        value: report && report.label ? report.label : null,
        label: 'label',
        placeholder: 'Ingrese el label',
        order: 1,
        validations: {
          validators: [Validators.required]
        }
      }),
      new Textbox({
        key: 'txtAlias',
        value: report && report.alias ? report.alias : null,
        label: 'Alias',
        placeholder: 'Ingrese un alias',
        order: 2,
        validations: {
          validators: [Validators.required]
        }
      }),
      new Textbox({
        key: 'chFiltroSubconsulta',
        type: 'checkbox',
        label: 'Filtro subconsulta',
        order: 3,
        size: 'col-12',
        value: report && report.filtro_subconsulta ? report.filtro_subconsulta : false,
        validations: {
          validators: []
        }
      }),
      new Textbox({
        key: 'txtAliasSubconsulta',
        value: report && report.alias_subconsulta ? report.alias_subconsulta : null,
        label: 'Alias Subconsulta',
        placeholder: 'Ingrese un alias',
        order: 4,
        condictions:[{
          campoDepende: 'chFiltroSubconsulta',
          siEs: 'Igual',
          valor: true,
          accion: 'Mostrar'
      }]
      }),
      new Textbox({
        key: 'txtOrden',
        type: 'number',
        value: report && report.orden ? report.orden : null,
        label: 'Orden',
        placeholder: 'ingrese el orden',
        order: 5,
        validations: {
          validators: [
            Validators.required]
        }
      }),
      new TextArea({
        key: 'txtCampo',
        value: report && report.campo ? JSON.stringify(report.campo) : null,
        label: 'Campo',
        placeholder: 'Ingrese el campo',
        order: 6,
        rows: '8'
        /*validations: {
          validators: [Validators.required]
        }*/
      }),
      new Textbox({
        key: 'txtEspacio',
        type: 'number',
        value: report && report.espacio ? report.espacio : null,
        label: 'Espacio',
        placeholder: 'Espacio',
        order: 7,
      }),
      new Textbox({
        key: 'chRequerido',
        type: 'checkbox',
        label: 'Requerido',
        order: 8,
        size: 'col-12',
        value: report && report.requerido ? report.requerido : false,
        validations: {
          validators: []
        }
      }),
      new Custom({
        key: 'cboTipoCampo',
        label: 'Tipo de campo',
        template: template,
        placeholder: 'Seleccione el tipo de campo',
        value: report && report.tipo_campo.id ? report.tipo_campo.id : null,
        options: options ? options : [],
        order: 9,
        size: 'col-md-12',
        validations: {
          validators: [Validators.required]
        },
      }),
      new Textbox({
        key: 'chSistema',
        type: 'checkbox',
        label: 'Sistema',
        order: 10,
        size: 'col-12',
        value: report && report.sistema ? report.sistema : false
      }),
      new Custom({
        key: 'cboModal',
        label: 'Modal',
        template: template,
        placeholder: 'Seleccione una opción',
        value: report && report.modal ? report.modal.id : null,
        options: options2 ? options2 : [],
        condictions: checkModal,
        order: 11,
        size: 'col-md-12',
        validations: {
          validators: [Validators.required]
        },
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-reports/reports/report-filter/shared/report-filter.form.service.ts